import React, { useState } from 'react'
import { Container, Box, Typography, Button } from '@mui/material'
import heroimg from "../assets/hero.png"
import LockIcon from '@mui/icons-material/Lock';
import LockOpenTwoToneIcon from '@mui/icons-material/LockOpenTwoTone';
import logoimg from "../assets/logo.png"
import { Link } from 'react-router-dom';
import { API_BASE_URL } from '../components/Config';
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from "notistack";


const ResetPassword = () => {

    const [showpss, setShowpss] = useState(false)
    const navigate = useNavigate()
    const { enqueueSnackbar } = useSnackbar();
    const [oldpassword ,setOldpassword] = useState()
    const [Newpassword ,setNewpassword] = useState()

    const resetAPIFunc = async()=>{
        try {
            const email = localStorage.getItem("email");
            
            const data = {
                password:oldpassword,
                password1:Newpassword,
                email:email,
            }
            console.log(data)
            const res = await axios.post(`${API_BASE_URL}/accounts/reset/`,data)
            enqueueSnackbar(res?.data?.msg, { variant: 'success' });
            console.log(res)
            navigate('/ResetSuccessfully');
        } catch (error) {
            console.log(error)
        }
    }



    return (
        <>
            <div className='back_Login'>
                <Container maxWidth="xl" className='login_container'>

                    <Box className='Login_image'>
                        <img src={heroimg} alt="images" />
                    </Box>
                    <Box className="form_Login">
                    <img src={logoimg} alt="" className='logo_login'/>
                        <Box>
                            <Typography variant="h3">Reset Password</Typography>
                            <p className='login_p'>Please enter the new password</p>
                        </Box>
                        <Box className="inputs_div">

                            <Box className="input_filde_divs">
                                <input type={`${showpss === true ? 'text' : 'password'}`} placeholder='New password' onChange={(e)=>setOldpassword(e.target.value)}/>
                                <Box onClick={()=>setShowpss(!showpss)} className="Login_icon">
                                    {showpss === true ? <LockOpenTwoToneIcon /> : < LockIcon />}
                                </Box>
                            </Box>

                            <Box className="input_filde_divs">
                                <input type={`${showpss === true ? 'text' : 'password'}`} placeholder='Confirm password' onChange={(e)=>setNewpassword(e.target.value)} />
                                <Box onClick={()=>setShowpss(!showpss)} className="Login_icon">
                                    {showpss === true ? <LockOpenTwoToneIcon /> : < LockIcon />}
                                </Box>
                            </Box>

                        </Box>
                        <Box>
                          <Link to='/ResetSuccessfully'>  
                            </Link>
                          <Button variant="contained" className='Login_btn  mt-3' onClick={resetAPIFunc}>
                            Reset Password
                            </Button>

                        </Box>

                    </Box>
                </Container>
            </div>
        </>
    )
}

export default ResetPassword
